// AntRichEditor — wrapper DevExtreme HtmlEditor, đồng bộ UX với
// NoteEditorPopup (sổ tay) trong AntRightSidebar. Dùng trong AntBaseForm
// qua editorType: 'antRichEditor'.
import React, { useState, useEffect, useCallback } from 'react';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';
import AntLocalization from '../../utils/AntLocalization';
import AntCondition from '../../utils/AntCondition';
import './index.scss';

function sanitizeHTML(html) {
    if (!html) return '';
    try {
        var DOMPurify = require('dompurify');
        if (DOMPurify && DOMPurify.sanitize) return DOMPurify.sanitize(html);
    } catch (e) { /* DOMPurify not installed */ }
    return String(html)
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .replace(/\bon\w+\s*=\s*"[^"]*"/gi, '')
        .replace(/\bon\w+\s*=\s*'[^']*'/gi, '')
        .replace(/javascript\s*:/gi, '');
}

function tr(v) { return !v ? '' : (typeof v === 'string' ? v : AntLocalization.translateText(v)); }

export function AntRichViewer(props) {
    var clean = sanitizeHTML(props.value);
    return (
        <div
            className={'ant-rich-viewer' + (props.className ? ' ' + props.className : '')}
            style={props.style}
            dangerouslySetInnerHTML={{ __html: clean }}
        />
    );
}

function AntRichEditor(props) {
    var value = props.value;
    var onChange = props.onChange;
    var placeholder = props.placeholder;
    var height = props.height || 260;
    var readOnly = !!props.readOnly;
    var className = props.className;
    var style = props.style;
    var visible = props.visible;
    var session = props.session;

    if (visible && session) {
        var isVis = AntCondition.checkAll({}, visible, session);
        if (!isVis) return null;
    }

    var [localValue, setLocalValue] = useState(value || '');
    useEffect(function () { setLocalValue(value || ''); }, [value]);

    var handleChange = useCallback(function (e) {
        var html = e && e.value != null ? e.value : '';
        setLocalValue(html);
        if (onChange) onChange(html);
    }, [onChange]);

    if (readOnly) {
        return (
            <div className={'ant-rich-editor ant-rich-editor-readonly' + (className ? ' ' + className : '')} style={style}>
                <AntRichViewer value={localValue} />
            </div>
        );
    }

    var phText = tr(placeholder);

    return (
        <div className={'ant-rich-editor ant-rich-editor-dx' + (className ? ' ' + className : '')} style={style}>
            <HtmlEditor
                className="ant-rich-editor-inner"
                value={localValue}
                onValueChanged={handleChange}
                placeholder={phText}
                height={height}
            >
                <Toolbar>
                    <Item name="header" acceptedValues={[1, 2, 3, false]} />
                    <Item name="separator" />
                    <Item name="bold" />
                    <Item name="italic" />
                    <Item name="underline" />
                    <Item name="strike" />
                    <Item name="separator" />
                    <Item name="color" />
                    <Item name="background" />
                    <Item name="separator" />
                    <Item name="orderedList" />
                    <Item name="bulletList" />
                    <Item name="separator" />
                    <Item name="alignLeft" />
                    <Item name="alignCenter" />
                    <Item name="alignRight" />
                    <Item name="separator" />
                    <Item name="increaseIndent" />
                    <Item name="decreaseIndent" />
                    <Item name="separator" />
                    <Item name="link" />
                    <Item name="image" />
                    <Item name="separator" />
                    <Item name="clear" />
                </Toolbar>
            </HtmlEditor>
        </div>
    );
}

AntRichEditor.Viewer = AntRichViewer;

export { AntRichEditor, sanitizeHTML };
export default AntRichEditor;
